import getFirstAvailableCollectionDate from 'api/firstAvailableDate/firstAvailableCollectionDate/getFirstAvailableCollectionDate';
import {
  GetCollectionFirstAvailableDateEndpoint,
  CollectionFirstAvailableDateResponse,
} from '@kouto/types';
import useSWR from 'swr';

type UseFirstAvailableCollectionDateProps = {
  brandId?: string | null;
  resourceGroupCollectionId?: string | null;
  skip?: boolean;
  from?: string | null;
  to?: string | null;
  isPrivate?: boolean;
  latest?: boolean;
};

const useFirstAvailableCollectionDate = ({
  brandId,
  resourceGroupCollectionId,
  skip = false,
  from,
  to,
  isPrivate,
  latest,
}: UseFirstAvailableCollectionDateProps) => {
  const url =
    skip || !brandId || !resourceGroupCollectionId
      ? null
      : GetCollectionFirstAvailableDateEndpoint.url({
          brandId,
          resourceGroupCollectionId,
          query: {
            from,
            to,
            private: isPrivate,
            latest,
          },
        });
  const swr = useSWR<CollectionFirstAvailableDateResponse>(
    url,
    getFirstAvailableCollectionDate,
  );

  return swr;
};

export default useFirstAvailableCollectionDate;
